import { addConditionOptionAction } from 'editor/src/store/design/slice';
import { ConditionAddress } from 'editor/src/store/design/types';
import type { Thunk } from 'editor/src/store/hooks';

import { conditionOptionUuids } from 'editor/src/util/uuids';

const addConditionOptionOperation =
  (address: ConditionAddress): Thunk =>
  (dispatch, getState, { i18n }) => {
    const optionId = conditionOptionUuids.generate();
    const condition =
      getState().design.designData?.spreads[address.spreadIndex]?.conditionGroup?.conditions[address.conditionId];
    const num = (condition?.options.length ?? 0) + 1;
    dispatch(addConditionOptionAction({ address, optionId, label: i18n.t('editor-default-option-num', { num }) }));
  };

export default addConditionOptionOperation;
